import cn from "classnames";
import Marquee from "react-fast-marquee";
import styles from "./styles.module.scss";

export const ImageCarousel = ({
  className = "",
  items,
  title = "Clients",
}) => {

  return (
    <section className={cn(className, styles.ImageCarousel)}>
      {title && (
        <div className={styles.headerContainer}>
          {title && <h3 className={`h2 ${styles.title}`}>{title}</h3>}
        </div>
      )}
      <div className={styles.marqueeContainer}>
        <Marquee
          speed={120}
          autoFill={true}
          gradientWidth={"65px"}
        >
          {items?.map((item, index) => (
            <div key={index} className="column">
              <img
                src={item.image?.url}
                alt={item.image?.alt || "Logo icon"}
                className={cn(styles.image, "img-fluid")}
              />
            </div>
          ))}
        </Marquee>
      </div>
      
    </section>
  );
}
